import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import admin from './admin';
import authentication from './authentication';
import conference from './conference';
import transcripts from './transcripts';
import organizations from './organizations';
import snackbar from './snackbar';
import conferences from './conferences';
import countries from './countries';
import introMessages from './introMessages';
import blockedAttendees from './blockedAttendees';
import sidebar from './sidebar';
import attendees from './attendees';
import trsc from './trscService';

export default combineReducers({
  admin,
  authentication,
  router: routerReducer,
  conference: conference(),
  transcript: conference('TRANSCRIPT_'),
  transcripts,
  organizations,
  snackbar,
  conferences,
  countries,
  introMessages,
  blockedAttendees,
  organizations,
  sidebar,
  attendees,
  trsc,
});



// WEBPACK FOOTER //
// ./redux/reducers/index.js